import { createAction } from 'redux-actions';
import { actionKey } from './constants';
export var initGroupsPanel = createAction("".concat(actionKey, ".INIT_GROUPS"), function () { return ({}); });
export var addToGroupFolder = createAction("".concat(actionKey, ".ADD_TO_FOLDER"), function (deviation, group, groupFolderId, actionbarType) { return ({
    deviation: deviation,
    group: group,
    groupFolderId: groupFolderId,
    actionbarType: actionbarType,
}); });
export var addToGroupFolderSuccess = createAction("".concat(actionKey, ".ADD_TO_FOLDER_SUCCESS"), function (deviationId, groupFolderId, suggested) { return ({
    deviationId: deviationId,
    groupFolderId: groupFolderId,
    suggested: suggested,
}); });
export var addToGroupFolderFail = createAction("".concat(actionKey, ".ADD_TO_FOLDER_FAIL"), function (deviationId, groupFolderId) { return ({
    deviationId: deviationId,
    groupFolderId: groupFolderId,
}); });
//# sourceMappingURL=actions.js.map